import { QuickApplyInfoParams, QuickApplyInfoResponse, ValidateStepParams } from './api/interfaces';
import { QuickApplyStep } from './enums';
import { Fields } from './redux/slices/quickApplySlice';

export const prepareQuickApplyDataForStepValidation = (fields: Fields, step: QuickApplyStep): ValidateStepParams => {
    switch (step) {
        case QuickApplyStep.PersonalInfo:
            return {
                name: fields.name,
                age: fields.age,
                cityId: fields.city?.id.toString() || '',
                citizenshipCountryId: fields.citizenshipCountryId,
                validate: true,
            };

        case QuickApplyStep.TextDescription:
            return {
                description: fields.description,
                validate: true,
            };

        default:
            console.error(`Invalid step ${step} provided!`);
            return {
                validate: true,
            };
    }
};

export const prepareQuickApplyDataForSubmit = (fields: Fields): QuickApplyInfoParams => {
    return {
        name: fields.name,
        age: fields.age,
        cityId: fields.city?.id.toString() || '',
        citizenshipCountryId: fields.citizenshipCountryId,
        description: fields.description,
    };
};

export const prepareQuickApplyFieldsData = (data: QuickApplyInfoResponse): Fields => {
    return {
        name: data.name,
        age: data.age,
        city: data.city,
        citizenshipCountryId: data.citizenshipCountryId,
        description: data.description,
    };
};
